// Базовий шар імпортується ПЕРШИМ: токени, скидання і примітиви розкладки мають
// стояти в бандлі до стилів компонентів. Раніше './index.css' імпортувався після
// App, тому правила з однаковою специфічністю (наприклад .reveal.is-visible проти
// .last-news-card:hover) вигравали в базового шару і гасили стани компонентів.
import './index.css';

import { BrowserRouter } from 'react-router-dom';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import store from 'redux/store';
import React from 'react';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Provider store={store}>
      <App />
    </Provider>
  </BrowserRouter>
);
